import { Link } from 'react-router-dom';
import StaticPageLayout from '@/components/layout/StaticPageLayout';
import distressedImg from '@/images/distressed.png';

export default function BlogPage() {
  return (
    <StaticPageLayout>
      {/* ============ HERO / HEADER ============ */}
      <section className="relative z-[6] -mt-[50px] bg-[#111] bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] text-center md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
      style={{ backgroundImage: `url(${distressedImg})` }}
      >
        <div className="mx-auto max-w-4xl px-6">
          <h1 className="font-heading text-[48px] uppercase tracking-[2px] text-primary-600 md:text-[85px]">
            BLOG
          </h1>
          <p className="mt-4 text-lg font-semibold text-primary-600">
            Insights, strategies, and real talk for independent musicians
          </p>
        </div>
      </section>

      {/* ============ BLOG POST LIST ============ */}
      <section className="relative -mt-[50px] bg-[#222] px-6 pb-32 pt-[calc(100px+50px)] md:-mt-[80px] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_100%,0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_100%,0_100%)]">
        <div className="mx-auto max-w-4xl space-y-8">
          {/* Blog Post Card 1 */}
          <Link
            to="/blog/music-marketing-plan-for-indie-artists"
            className="block group no-underline"
          >
            <article className="rounded-lg border border-neutral-300 bg-neutral-200 p-8 transition-shadow hover:shadow-lg">
              <p className="text-sm font-semibold uppercase tracking-wider text-primary-600">
                Marketing Strategy
              </p>
              <h2 className="mt-2 font-heading text-3xl uppercase text-white transition-colors group-hover:text-primary-600 sm:text-4xl">
                THE MUSIC MARKETING PLAN THAT ACTUALLY WORKS: LESSONS FROM A DOZEN INDUSTRY INSIDERS
              </h2>
              <p className="mt-4 text-lg text-neutral-600">
                Most music marketing advice is generic, repetitive, and useless.
                We talked to booking agents, promoters, merch veterans, and
                touring musicians to find out what actually moves the needle for
                independent artists. Here's what they told us.
              </p>
              <p className="mt-4 text-sm text-neutral-500">
                July 2026 · 10 min read
              </p>
            </article>
          </Link>

          {/* Blog Post Card 2 */}
          <Link
            to="/blog/your-show-has-to-feel-like-something"
            className="block group no-underline"
          >
            <article className="rounded-lg border border-neutral-300 bg-neutral-200 p-8 transition-shadow hover:shadow-lg">
              <p className="text-sm font-semibold uppercase tracking-wider text-primary-600">
                Live Shows
              </p>
              <h2 className="mt-2 font-heading text-3xl uppercase text-white transition-colors group-hover:text-primary-600 sm:text-4xl">
                YOUR SHOW HAS TO FEEL LIKE SOMETHING
              </h2>
              <p className="mt-4 text-lg text-neutral-600">
                People have endless reasons not to go out. If you're going to
                overcome all that, the show has to feel like something bigger
                than "our band is playing." Here's how to curate a night out instead of
                just book a gig.
              </p>
              <p className="mt-4 text-sm text-neutral-500">
                July 2026 · 7 min read
              </p>
            </article>
          </Link>

          {/* Blog Post Card 3 */}
          <Link
            to="/blog/how-to-turn-a-friend-base-into-a-fan-base"
            className="block group no-underline"
          >
            <article className="rounded-lg border border-neutral-300 bg-neutral-200 p-8 transition-shadow hover:shadow-lg">
              <p className="text-sm font-semibold uppercase tracking-wider text-primary-600">
                Audience Growth
              </p>
              <h2 className="mt-2 font-heading text-3xl uppercase text-white transition-colors group-hover:text-primary-600 sm:text-4xl">
                HOW TO TURN A FRIEND BASE INTO A FAN BASE
              </h2>
              <p className="mt-4 text-lg text-neutral-600">
                Every band's earliest supporters are friends. That's not a
                problem, it's just how it works. But at some point, a loyal
                friend base becomes a ceiling. Here's how to build wider circles
                and turn personal connections into real audience growth.
              </p>
              <p className="mt-4 text-sm text-neutral-500">
                July 2026 · 8 min read
              </p>
            </article>
          </Link>
        </div>
      </section>
    </StaticPageLayout>
  );
}
